import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import BranchIcon from "../../Icons/BranchIcon";
const BranchListComponent = loadable(() => import("../../components/Branch/"));

const BranchList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["branch"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <BranchIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Branch</span>
      </div>
      <BranchListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default BranchList;
